module.exports = __webpack_public_path__ + "static/media/img-5.cc214368.jpeg";